// @formatter:off
/**
 * Kita-Scheduler
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// noinspection ES6UnusedImports
import {HttpClient, HttpContext, HttpEvent, HttpParams, HttpResponse} from '@angular/common/http';
import {Inject, Injectable, Optional} from '@angular/core';
import type {AdressenResourceGetMitbewohnerMitbewohnerParameter} from '@dv/shared/backend/model/adressen-resource-get-mitbewohner-mitbewohner-parameter';
import type {EntityId} from '@dv/shared/backend/model/entity-id';
import type {JaxApproval} from '@dv/shared/backend/model/jax-approval';
import type {JaxParameterCoronaRefunds} from '@dv/shared/backend/model/jax-parameter-corona-refunds';
import type {JaxParameterKitas} from '@dv/shared/backend/model/jax-parameter-kitas';
import type {JaxTempBlob} from '@dv/shared/backend/model/jax-temp-blob';
import type {ReportingBetriebResourceAktuelleAenderungenJahrMatrixParameter} from '@dv/shared/backend/model/reporting-betrieb-resource-aktuelle-aenderungen-jahr-matrix-parameter';
import type {ReportingBetriebResourceGetAbweichungenKinderortFraktionReportFraktionIdMatrixParameter} from '@dv/shared/backend/model/reporting-betrieb-resource-get-abweichungen-kinderort-fraktion-report-fraktion-id-matrix-parameter';
import type {ReportingBetriebResourceGetAdresslisteKinderKontakteKinderkontakteParameter} from '@dv/shared/backend/model/reporting-betrieb-resource-get-adressliste-kinder-kontakte-kinderkontakte-parameter';
import type {ReportingControllingResourceGetBelegungsplanMonthlyWithFraktionBelegungsplanMonthlyParameter} from '@dv/shared/backend/model/reporting-controlling-resource-get-belegungsplan-monthly-with-fraktion-belegungsplan-monthly-parameter';
import type {ReportingControllingResourceGetBetreuungsvereinbarungenBetreuungsvereinbarungenParameter} from '@dv/shared/backend/model/reporting-controlling-resource-get-betreuungsvereinbarungen-betreuungsvereinbarungen-parameter';
import type {ReportingControllingResourceGetControllingDataKinderOrtIdMatrixParameter} from '@dv/shared/backend/model/reporting-controlling-resource-get-controlling-data-kinder-ort-id-matrix-parameter';
import type {ReportingControllingResourceGetMonatsblattAuszugMonatsblaetterParameter} from '@dv/shared/backend/model/reporting-controlling-resource-get-monatsblatt-auszug-monatsblaetter-parameter';
import type {ReportingControllingResourceGetPraesenzkontrolleFraktionReportFraktionenParameter} from '@dv/shared/backend/model/reporting-controlling-resource-get-praesenzkontrolle-fraktion-report-fraktionen-parameter';
import type {ReportingControllingResourceGetPraesenzkontrolleKgFraktionReportFraktionenParameter} from '@dv/shared/backend/model/reporting-controlling-resource-get-praesenzkontrolle-kg-fraktion-report-fraktionen-parameter';
import type {ReportingControllingResourceGetPraesenzkontrolleReportKinderOrtIdMatrixParameter} from '@dv/shared/backend/model/reporting-controlling-resource-get-praesenzkontrolle-report-kinder-ort-id-matrix-parameter';
import {Observable} from 'rxjs';
import {BaseService} from '../api.base.service';
import {Configuration} from '../configuration';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS} from '../variables';

export interface ReportingControllingApiBetreuungsStundenKontrolleRequestParams {
    kinderOrtId: EntityId;
    kinderOrtIdMatrix: AdressenResourceGetMitbewohnerMitbewohnerParameter;
}

export interface ReportingControllingApiFeeApprovalRequestParams {
    kinderOrtId: EntityId;
}

export interface ReportingControllingApiGetAnwesenheitsSollReportRequestParams {
    anwesenheitssoll: ReportingBetriebResourceGetAbweichungenKinderortFraktionReportFraktionIdMatrixParameter;
    kinderOrtId: EntityId;
    userAgent?: string;
}

export interface ReportingControllingApiGetBelegteProzentPunkteRequestParams {
    kinderOrtId: EntityId;
    kinderOrtIdMatrix: ReportingBetriebResourceGetAbweichungenKinderortFraktionReportFraktionIdMatrixParameter;
    userAgent?: string;
}

export interface ReportingControllingApiGetBelegungsplanRequestParams {
    belegungsplan: ReportingControllingResourceGetBelegungsplanMonthlyWithFraktionBelegungsplanMonthlyParameter;
    kinderOrtId: EntityId;
    userAgent?: string;
}

export interface ReportingControllingApiGetBelegungsplanMonthlyRequestParams {
    belegungsplanMonthly: ReportingControllingResourceGetBelegungsplanMonthlyWithFraktionBelegungsplanMonthlyParameter;
    kinderOrtId: EntityId;
    userAgent?: string;
}

export interface ReportingControllingApiGetBelegungsplanMonthlyWithFraktionRequestParams {
    belegungsplanMonthly: ReportingControllingResourceGetBelegungsplanMonthlyWithFraktionBelegungsplanMonthlyParameter;
    fraktionId: EntityId;
    userAgent?: string;
}

export interface ReportingControllingApiGetBetreuungsGutscheineRequestParams {
    betreuungsgutscheine: ReportingBetriebResourceGetAbweichungenKinderortFraktionReportFraktionIdMatrixParameter;
    userAgent?: string;
    jaxParameterKitas: JaxParameterKitas;
}

export interface ReportingControllingApiGetBetreuungsvereinbarungenRequestParams {
    betreuungsvereinbarungen: ReportingControllingResourceGetBetreuungsvereinbarungenBetreuungsvereinbarungenParameter;
    kinderOrtId: EntityId;
}

export interface ReportingControllingApiGetControllingRequestParams {
    jahr: number;
    jahrMatrix: ReportingBetriebResourceAktuelleAenderungenJahrMatrixParameter;
    kinderOrtId: EntityId;
    userAgent?: string;
}

export interface ReportingControllingApiGetControllingDataRequestParams {
    kinderOrtId: EntityId;
    kinderOrtIdMatrix: ReportingControllingResourceGetControllingDataKinderOrtIdMatrixParameter;
}

export interface ReportingControllingApiGetControllingMonthlyRequestParams {
    monthly: ReportingBetriebResourceGetAdresslisteKinderKontakteKinderkontakteParameter;
    userAgent?: string;
    jaxParameterKitas: JaxParameterKitas;
}

export interface ReportingControllingApiGetCoronaRefundsRequestParams {
    kinderOrtId: EntityId;
    kinderOrtIdMatrix: ReportingBetriebResourceGetAdresslisteKinderKontakteKinderkontakteParameter;
    userAgent?: string;
    jaxParameterCoronaRefunds: JaxParameterCoronaRefunds;
}

export interface ReportingControllingApiGetExternalAnmeldungenRequestParams {
    externalAnmeldungen: ReportingBetriebResourceGetAbweichungenKinderortFraktionReportFraktionIdMatrixParameter;
    userAgent?: string;
}

export interface ReportingControllingApiGetFinanzlastenausgleichRequestParams {
    finanzlastenausgleich: ReportingBetriebResourceGetAdresslisteKinderKontakteKinderkontakteParameter;
    userAgent?: string;
    jaxParameterKitas: JaxParameterKitas;
}

export interface ReportingControllingApiGetGroupAdminKindTagesInfosRequestParams {
    kindId: EntityId;
    kindIdMatrix: AdressenResourceGetMitbewohnerMitbewohnerParameter;
}

export interface ReportingControllingApiGetKalkulierteLeistungenRequestParams {
    kalkuliert: ReportingBetriebResourceGetAbweichungenKinderortFraktionReportFraktionIdMatrixParameter;
    kinderOrtId: EntityId;
    userAgent?: string;
}

export interface ReportingControllingApiGetKalkuliertesTarifreportingRequestParams {
    kinderOrtId: EntityId;
    kinderOrtIdMatrix: ReportingBetriebResourceGetAbweichungenKinderortFraktionReportFraktionIdMatrixParameter;
    userAgent?: string;
}

export interface ReportingControllingApiGetKennzahlenRequestParams {
    kennzahlen: ReportingBetriebResourceGetAbweichungenKinderortFraktionReportFraktionIdMatrixParameter;
    userAgent?: string;
}

export interface ReportingControllingApiGetKibonDatenRequestParams {
    kibonReport: ReportingBetriebResourceGetAdresslisteKinderKontakteKinderkontakteParameter;
    userAgent?: string;
    jaxParameterKitas: JaxParameterKitas;
}

export interface ReportingControllingApiGetKindStundenvergleichRequestParams {
    kindId: EntityId;
    kindIdMatrix: ReportingBetriebResourceGetAbweichungenKinderortFraktionReportFraktionIdMatrixParameter;
    userAgent?: string;
}

export interface ReportingControllingApiGetMonatsblattAuszugRequestParams {
    kinderOrtId: EntityId;
    monatsblaetter: ReportingControllingResourceGetMonatsblattAuszugMonatsblaetterParameter;
}

export interface ReportingControllingApiGetPraesenzkontrolleFraktionReportRequestParams {
    fraktionen: ReportingControllingResourceGetPraesenzkontrolleFraktionReportFraktionenParameter;
    userAgent?: string;
}

export interface ReportingControllingApiGetPraesenzkontrolleKgFraktionReportRequestParams {
    fraktionen: ReportingControllingResourceGetPraesenzkontrolleKgFraktionReportFraktionenParameter;
    userAgent?: string;
}

export interface ReportingControllingApiGetPraesenzkontrolleKgReportRequestParams {
    kinderOrtId: EntityId;
    kinderOrtIdMatrix: ReportingBetriebResourceGetAbweichungenKinderortFraktionReportFraktionIdMatrixParameter;
    userAgent?: string;
}

export interface ReportingControllingApiGetPraesenzkontrolleReportRequestParams {
    kinderOrtId: EntityId;
    kinderOrtIdMatrix: ReportingControllingResourceGetPraesenzkontrolleReportKinderOrtIdMatrixParameter;
    userAgent?: string;
}

export interface ReportingControllingApiGetStundenbasiertesControllingRequestParams {
    jahr: number;
    jahrMatrix: ReportingBetriebResourceGetAdresslisteKinderKontakteKinderkontakteParameter;
    kinderOrtId: EntityId;
    userAgent?: string;
}

export interface ReportingControllingApiGetStundenblattRequestParams {
    kinderOrtId: EntityId;
    stundenblatt: ReportingBetriebResourceGetAbweichungenKinderortFraktionReportFraktionIdMatrixParameter;
    userAgent?: string;
}

export interface ReportingControllingApiGetWartelisteRequestParams {
    warteliste: ReportingBetriebResourceGetAdresslisteKinderKontakteKinderkontakteParameter;
    userAgent?: string;
    jaxParameterKitas: JaxParameterKitas;
}

@Injectable({
  providedIn: 'root'
})
export class ReportingControllingApi extends BaseService {

    constructor(
        protected httpClient: HttpClient,
        @Optional() @Inject(BASE_PATH) basePath: string|string[],
        @Optional() configuration?: Configuration,
    ) {
        super(basePath, configuration);
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public betreuungsStundenKontrolle$(requestParameters: ReportingControllingApiBetreuungsStundenKontrolleRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public betreuungsStundenKontrolle$(requestParameters: ReportingControllingApiBetreuungsStundenKontrolleRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public betreuungsStundenKontrolle$(requestParameters: ReportingControllingApiBetreuungsStundenKontrolleRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public betreuungsStundenKontrolle$(requestParameters: ReportingControllingApiBetreuungsStundenKontrolleRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const kinderOrtId = requestParameters.kinderOrtId;
        if (kinderOrtId === null || kinderOrtId === undefined) {
            throw new Error('Required parameter kinderOrtId was null or undefined when calling betreuungsStundenKontrolle$.');
        }
        const kinderOrtIdMatrix = requestParameters.kinderOrtIdMatrix;
        if (kinderOrtIdMatrix === null || kinderOrtIdMatrix === undefined) {
            throw new Error('Required parameter kinderOrtIdMatrix was null or undefined when calling betreuungsStundenKontrolle$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/reporting/controlling/betreuungsstundenkontrolle/${this.configuration.encodeParam({name: "kinderOrtId", value: kinderOrtId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}${this.configuration.encodeParam({name: "kinderOrtIdMatrix", value: kinderOrtIdMatrix, in: "path", style: "matrix", explode: true, dataType: "AdressenResourceGetMitbewohnerMitbewohnerParameter", dataFormat: undefined})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<any>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public feeApproval$(requestParameters: ReportingControllingApiFeeApprovalRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<JaxApproval>;
    public feeApproval$(requestParameters: ReportingControllingApiFeeApprovalRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<JaxApproval>>;
    public feeApproval$(requestParameters: ReportingControllingApiFeeApprovalRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<JaxApproval>>;
    public feeApproval$(requestParameters: ReportingControllingApiFeeApprovalRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const kinderOrtId = requestParameters.kinderOrtId;
        if (kinderOrtId === null || kinderOrtId === undefined) {
            throw new Error('Required parameter kinderOrtId was null or undefined when calling feeApproval$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/reporting/controlling/feeapproval/coronarefund/${this.configuration.encodeParam({name: "kinderOrtId", value: kinderOrtId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<JaxApproval>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public getAnwesenheitsSollReport$(requestParameters: ReportingControllingApiGetAnwesenheitsSollReportRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<JaxTempBlob>;
    public getAnwesenheitsSollReport$(requestParameters: ReportingControllingApiGetAnwesenheitsSollReportRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<JaxTempBlob>>;
    public getAnwesenheitsSollReport$(requestParameters: ReportingControllingApiGetAnwesenheitsSollReportRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<JaxTempBlob>>;
    public getAnwesenheitsSollReport$(requestParameters: ReportingControllingApiGetAnwesenheitsSollReportRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const anwesenheitssoll = requestParameters.anwesenheitssoll;
        if (anwesenheitssoll === null || anwesenheitssoll === undefined) {
            throw new Error('Required parameter anwesenheitssoll was null or undefined when calling getAnwesenheitsSollReport$.');
        }
        const kinderOrtId = requestParameters.kinderOrtId;
        if (kinderOrtId === null || kinderOrtId === undefined) {
            throw new Error('Required parameter kinderOrtId was null or undefined when calling getAnwesenheitsSollReport$.');
        }
        const userAgent = requestParameters.userAgent;

        let localVarHeaders = this.defaultHeaders;
        if (userAgent !== undefined && userAgent !== null) {
            localVarHeaders = localVarHeaders.set('User-Agent', String(userAgent));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/reporting/controlling/excel/kita/${this.configuration.encodeParam({name: "kinderOrtId", value: kinderOrtId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}/anwesenheitssoll${this.configuration.encodeParam({name: "anwesenheitssoll", value: anwesenheitssoll, in: "path", style: "matrix", explode: true, dataType: "ReportingBetriebResourceGetAbweichungenKinderortFraktionReportFraktionIdMatrixParameter", dataFormat: undefined})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<JaxTempBlob>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public getBelegteProzentPunkte$(requestParameters: ReportingControllingApiGetBelegteProzentPunkteRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<JaxTempBlob>;
    public getBelegteProzentPunkte$(requestParameters: ReportingControllingApiGetBelegteProzentPunkteRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<JaxTempBlob>>;
    public getBelegteProzentPunkte$(requestParameters: ReportingControllingApiGetBelegteProzentPunkteRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<JaxTempBlob>>;
    public getBelegteProzentPunkte$(requestParameters: ReportingControllingApiGetBelegteProzentPunkteRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const kinderOrtId = requestParameters.kinderOrtId;
        if (kinderOrtId === null || kinderOrtId === undefined) {
            throw new Error('Required parameter kinderOrtId was null or undefined when calling getBelegteProzentPunkte$.');
        }
        const kinderOrtIdMatrix = requestParameters.kinderOrtIdMatrix;
        if (kinderOrtIdMatrix === null || kinderOrtIdMatrix === undefined) {
            throw new Error('Required parameter kinderOrtIdMatrix was null or undefined when calling getBelegteProzentPunkte$.');
        }
        const userAgent = requestParameters.userAgent;

        let localVarHeaders = this.defaultHeaders;
        if (userAgent !== undefined && userAgent !== null) {
            localVarHeaders = localVarHeaders.set('User-Agent', String(userAgent));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/reporting/controlling/excel/belegteprozentpunkte/${this.configuration.encodeParam({name: "kinderOrtId", value: kinderOrtId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}${this.configuration.encodeParam({name: "kinderOrtIdMatrix", value: kinderOrtIdMatrix, in: "path", style: "matrix", explode: true, dataType: "ReportingBetriebResourceGetAbweichungenKinderortFraktionReportFraktionIdMatrixParameter", dataFormat: undefined})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<JaxTempBlob>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public getBelegungsplan$(requestParameters: ReportingControllingApiGetBelegungsplanRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<JaxTempBlob>;
    public getBelegungsplan$(requestParameters: ReportingControllingApiGetBelegungsplanRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<JaxTempBlob>>;
    public getBelegungsplan$(requestParameters: ReportingControllingApiGetBelegungsplanRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<JaxTempBlob>>;
    public getBelegungsplan$(requestParameters: ReportingControllingApiGetBelegungsplanRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const belegungsplan = requestParameters.belegungsplan;
        if (belegungsplan === null || belegungsplan === undefined) {
            throw new Error('Required parameter belegungsplan was null or undefined when calling getBelegungsplan$.');
        }
        const kinderOrtId = requestParameters.kinderOrtId;
        if (kinderOrtId === null || kinderOrtId === undefined) {
            throw new Error('Required parameter kinderOrtId was null or undefined when calling getBelegungsplan$.');
        }
        const userAgent = requestParameters.userAgent;

        let localVarHeaders = this.defaultHeaders;
        if (userAgent !== undefined && userAgent !== null) {
            localVarHeaders = localVarHeaders.set('User-Agent', String(userAgent));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/reporting/controlling/excel/kita/${this.configuration.encodeParam({name: "kinderOrtId", value: kinderOrtId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}/belegungsplan${this.configuration.encodeParam({name: "belegungsplan", value: belegungsplan, in: "path", style: "matrix", explode: true, dataType: "ReportingControllingResourceGetBelegungsplanMonthlyWithFraktionBelegungsplanMonthlyParameter", dataFormat: undefined})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<JaxTempBlob>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public getBelegungsplanMonthly$(requestParameters: ReportingControllingApiGetBelegungsplanMonthlyRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<JaxTempBlob>;
    public getBelegungsplanMonthly$(requestParameters: ReportingControllingApiGetBelegungsplanMonthlyRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<JaxTempBlob>>;
    public getBelegungsplanMonthly$(requestParameters: ReportingControllingApiGetBelegungsplanMonthlyRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<JaxTempBlob>>;
    public getBelegungsplanMonthly$(requestParameters: ReportingControllingApiGetBelegungsplanMonthlyRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const belegungsplanMonthly = requestParameters.belegungsplanMonthly;
        if (belegungsplanMonthly === null || belegungsplanMonthly === undefined) {
            throw new Error('Required parameter belegungsplanMonthly was null or undefined when calling getBelegungsplanMonthly$.');
        }
        const kinderOrtId = requestParameters.kinderOrtId;
        if (kinderOrtId === null || kinderOrtId === undefined) {
            throw new Error('Required parameter kinderOrtId was null or undefined when calling getBelegungsplanMonthly$.');
        }
        const userAgent = requestParameters.userAgent;

        let localVarHeaders = this.defaultHeaders;
        if (userAgent !== undefined && userAgent !== null) {
            localVarHeaders = localVarHeaders.set('User-Agent', String(userAgent));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/reporting/controlling/excel/kita/${this.configuration.encodeParam({name: "kinderOrtId", value: kinderOrtId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}/belegungsplan-monthly${this.configuration.encodeParam({name: "belegungsplanMonthly", value: belegungsplanMonthly, in: "path", style: "matrix", explode: true, dataType: "ReportingControllingResourceGetBelegungsplanMonthlyWithFraktionBelegungsplanMonthlyParameter", dataFormat: undefined})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<JaxTempBlob>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public getBelegungsplanMonthlyWithFraktion$(requestParameters: ReportingControllingApiGetBelegungsplanMonthlyWithFraktionRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<JaxTempBlob>;
    public getBelegungsplanMonthlyWithFraktion$(requestParameters: ReportingControllingApiGetBelegungsplanMonthlyWithFraktionRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<JaxTempBlob>>;
    public getBelegungsplanMonthlyWithFraktion$(requestParameters: ReportingControllingApiGetBelegungsplanMonthlyWithFraktionRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<JaxTempBlob>>;
    public getBelegungsplanMonthlyWithFraktion$(requestParameters: ReportingControllingApiGetBelegungsplanMonthlyWithFraktionRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const belegungsplanMonthly = requestParameters.belegungsplanMonthly;
        if (belegungsplanMonthly === null || belegungsplanMonthly === undefined) {
            throw new Error('Required parameter belegungsplanMonthly was null or undefined when calling getBelegungsplanMonthlyWithFraktion$.');
        }
        const fraktionId = requestParameters.fraktionId;
        if (fraktionId === null || fraktionId === undefined) {
            throw new Error('Required parameter fraktionId was null or undefined when calling getBelegungsplanMonthlyWithFraktion$.');
        }
        const userAgent = requestParameters.userAgent;

        let localVarHeaders = this.defaultHeaders;
        if (userAgent !== undefined && userAgent !== null) {
            localVarHeaders = localVarHeaders.set('User-Agent', String(userAgent));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/reporting/controlling/excel/gruppe/${this.configuration.encodeParam({name: "fraktionId", value: fraktionId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}/belegungsplan-monthly${this.configuration.encodeParam({name: "belegungsplanMonthly", value: belegungsplanMonthly, in: "path", style: "matrix", explode: true, dataType: "ReportingControllingResourceGetBelegungsplanMonthlyWithFraktionBelegungsplanMonthlyParameter", dataFormat: undefined})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<JaxTempBlob>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public getBetreuungsGutscheine$(requestParameters: ReportingControllingApiGetBetreuungsGutscheineRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<JaxTempBlob>;
    public getBetreuungsGutscheine$(requestParameters: ReportingControllingApiGetBetreuungsGutscheineRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<JaxTempBlob>>;
    public getBetreuungsGutscheine$(requestParameters: ReportingControllingApiGetBetreuungsGutscheineRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<JaxTempBlob>>;
    public getBetreuungsGutscheine$(requestParameters: ReportingControllingApiGetBetreuungsGutscheineRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const betreuungsgutscheine = requestParameters.betreuungsgutscheine;
        if (betreuungsgutscheine === null || betreuungsgutscheine === undefined) {
            throw new Error('Required parameter betreuungsgutscheine was null or undefined when calling getBetreuungsGutscheine$.');
        }
        const userAgent = requestParameters.userAgent;
        const jaxParameterKitas = requestParameters.jaxParameterKitas;
        if (jaxParameterKitas === null || jaxParameterKitas === undefined) {
            throw new Error('Required parameter jaxParameterKitas was null or undefined when calling getBetreuungsGutscheine$.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (userAgent !== undefined && userAgent !== null) {
            localVarHeaders = localVarHeaders.set('User-Agent', String(userAgent));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/reporting/controlling/excel/betreuungsgutscheine${this.configuration.encodeParam({name: "betreuungsgutscheine", value: betreuungsgutscheine, in: "path", style: "matrix", explode: true, dataType: "ReportingBetriebResourceGetAbweichungenKinderortFraktionReportFraktionIdMatrixParameter", dataFormat: undefined})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<JaxTempBlob>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: jaxParameterKitas,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public getBetreuungsvereinbarungen$(requestParameters: ReportingControllingApiGetBetreuungsvereinbarungenRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<JaxTempBlob>;
    public getBetreuungsvereinbarungen$(requestParameters: ReportingControllingApiGetBetreuungsvereinbarungenRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<JaxTempBlob>>;
    public getBetreuungsvereinbarungen$(requestParameters: ReportingControllingApiGetBetreuungsvereinbarungenRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<JaxTempBlob>>;
    public getBetreuungsvereinbarungen$(requestParameters: ReportingControllingApiGetBetreuungsvereinbarungenRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const betreuungsvereinbarungen = requestParameters.betreuungsvereinbarungen;
        if (betreuungsvereinbarungen === null || betreuungsvereinbarungen === undefined) {
            throw new Error('Required parameter betreuungsvereinbarungen was null or undefined when calling getBetreuungsvereinbarungen$.');
        }
        const kinderOrtId = requestParameters.kinderOrtId;
        if (kinderOrtId === null || kinderOrtId === undefined) {
            throw new Error('Required parameter kinderOrtId was null or undefined when calling getBetreuungsvereinbarungen$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/reporting/controlling/zip/kinderort/${this.configuration.encodeParam({name: "kinderOrtId", value: kinderOrtId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}/betreuungsvereinbarungen${this.configuration.encodeParam({name: "betreuungsvereinbarungen", value: betreuungsvereinbarungen, in: "path", style: "matrix", explode: true, dataType: "ReportingControllingResourceGetBetreuungsvereinbarungenBetreuungsvereinbarungenParameter", dataFormat: undefined})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<JaxTempBlob>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public getControlling$(requestParameters: ReportingControllingApiGetControllingRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<JaxTempBlob>;
    public getControlling$(requestParameters: ReportingControllingApiGetControllingRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<JaxTempBlob>>;
    public getControlling$(requestParameters: ReportingControllingApiGetControllingRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<JaxTempBlob>>;
    public getControlling$(requestParameters: ReportingControllingApiGetControllingRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const jahr = requestParameters.jahr;
        if (jahr === null || jahr === undefined) {
            throw new Error('Required parameter jahr was null or undefined when calling getControlling$.');
        }
        const jahrMatrix = requestParameters.jahrMatrix;
        if (jahrMatrix === null || jahrMatrix === undefined) {
            throw new Error('Required parameter jahrMatrix was null or undefined when calling getControlling$.');
        }
        const kinderOrtId = requestParameters.kinderOrtId;
        if (kinderOrtId === null || kinderOrtId === undefined) {
            throw new Error('Required parameter kinderOrtId was null or undefined when calling getControlling$.');
        }
        const userAgent = requestParameters.userAgent;

        let localVarHeaders = this.defaultHeaders;
        if (userAgent !== undefined && userAgent !== null) {
            localVarHeaders = localVarHeaders.set('User-Agent', String(userAgent));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/reporting/controlling/excel/kita/${this.configuration.encodeParam({name: "kinderOrtId", value: kinderOrtId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}/controlling/jahresauswertung/${this.configuration.encodeParam({name: "jahr", value: jahr, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int32"})}${this.configuration.encodeParam({name: "jahrMatrix", value: jahrMatrix, in: "path", style: "matrix", explode: true, dataType: "ReportingBetriebResourceAktuelleAenderungenJahrMatrixParameter", dataFormat: undefined})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<JaxTempBlob>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public getControllingData$(requestParameters: ReportingControllingApiGetControllingDataRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public getControllingData$(requestParameters: ReportingControllingApiGetControllingDataRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public getControllingData$(requestParameters: ReportingControllingApiGetControllingDataRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public getControllingData$(requestParameters: ReportingControllingApiGetControllingDataRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const kinderOrtId = requestParameters.kinderOrtId;
        if (kinderOrtId === null || kinderOrtId === undefined) {
            throw new Error('Required parameter kinderOrtId was null or undefined when calling getControllingData$.');
        }
        const kinderOrtIdMatrix = requestParameters.kinderOrtIdMatrix;
        if (kinderOrtIdMatrix === null || kinderOrtIdMatrix === undefined) {
            throw new Error('Required parameter kinderOrtIdMatrix was null or undefined when calling getControllingData$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/reporting/controlling/${this.configuration.encodeParam({name: "kinderOrtId", value: kinderOrtId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}${this.configuration.encodeParam({name: "kinderOrtIdMatrix", value: kinderOrtIdMatrix, in: "path", style: "matrix", explode: true, dataType: "ReportingControllingResourceGetControllingDataKinderOrtIdMatrixParameter", dataFormat: undefined})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<any>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public getControllingMonthly$(requestParameters: ReportingControllingApiGetControllingMonthlyRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public getControllingMonthly$(requestParameters: ReportingControllingApiGetControllingMonthlyRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public getControllingMonthly$(requestParameters: ReportingControllingApiGetControllingMonthlyRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public getControllingMonthly$(requestParameters: ReportingControllingApiGetControllingMonthlyRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const monthly = requestParameters.monthly;
        if (monthly === null || monthly === undefined) {
            throw new Error('Required parameter monthly was null or undefined when calling getControllingMonthly$.');
        }
        const userAgent = requestParameters.userAgent;
        const jaxParameterKitas = requestParameters.jaxParameterKitas;
        if (jaxParameterKitas === null || jaxParameterKitas === undefined) {
            throw new Error('Required parameter jaxParameterKitas was null or undefined when calling getControllingMonthly$.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (userAgent !== undefined && userAgent !== null) {
            localVarHeaders = localVarHeaders.set('User-Agent', String(userAgent));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/reporting/controlling/excel/controlling/monthly${this.configuration.encodeParam({name: "monthly", value: monthly, in: "path", style: "matrix", explode: true, dataType: "ReportingBetriebResourceGetAdresslisteKinderKontakteKinderkontakteParameter", dataFormat: undefined})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: jaxParameterKitas,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public getCoronaRefunds$(requestParameters: ReportingControllingApiGetCoronaRefundsRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public getCoronaRefunds$(requestParameters: ReportingControllingApiGetCoronaRefundsRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public getCoronaRefunds$(requestParameters: ReportingControllingApiGetCoronaRefundsRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public getCoronaRefunds$(requestParameters: ReportingControllingApiGetCoronaRefundsRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const kinderOrtId = requestParameters.kinderOrtId;
        if (kinderOrtId === null || kinderOrtId === undefined) {
            throw new Error('Required parameter kinderOrtId was null or undefined when calling getCoronaRefunds$.');
        }
        const kinderOrtIdMatrix = requestParameters.kinderOrtIdMatrix;
        if (kinderOrtIdMatrix === null || kinderOrtIdMatrix === undefined) {
            throw new Error('Required parameter kinderOrtIdMatrix was null or undefined when calling getCoronaRefunds$.');
        }
        const userAgent = requestParameters.userAgent;
        const jaxParameterCoronaRefunds = requestParameters.jaxParameterCoronaRefunds;
        if (jaxParameterCoronaRefunds === null || jaxParameterCoronaRefunds === undefined) {
            throw new Error('Required parameter jaxParameterCoronaRefunds was null or undefined when calling getCoronaRefunds$.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (userAgent !== undefined && userAgent !== null) {
            localVarHeaders = localVarHeaders.set('User-Agent', String(userAgent));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/reporting/controlling/excel/coronarefund/${this.configuration.encodeParam({name: "kinderOrtId", value: kinderOrtId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}${this.configuration.encodeParam({name: "kinderOrtIdMatrix", value: kinderOrtIdMatrix, in: "path", style: "matrix", explode: true, dataType: "ReportingBetriebResourceGetAdresslisteKinderKontakteKinderkontakteParameter", dataFormat: undefined})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: jaxParameterCoronaRefunds,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public getExternalAnmeldungen$(requestParameters: ReportingControllingApiGetExternalAnmeldungenRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<JaxTempBlob>;
    public getExternalAnmeldungen$(requestParameters: ReportingControllingApiGetExternalAnmeldungenRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<JaxTempBlob>>;
    public getExternalAnmeldungen$(requestParameters: ReportingControllingApiGetExternalAnmeldungenRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<JaxTempBlob>>;
    public getExternalAnmeldungen$(requestParameters: ReportingControllingApiGetExternalAnmeldungenRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const externalAnmeldungen = requestParameters.externalAnmeldungen;
        if (externalAnmeldungen === null || externalAnmeldungen === undefined) {
            throw new Error('Required parameter externalAnmeldungen was null or undefined when calling getExternalAnmeldungen$.');
        }
        const userAgent = requestParameters.userAgent;

        let localVarHeaders = this.defaultHeaders;
        if (userAgent !== undefined && userAgent !== null) {
            localVarHeaders = localVarHeaders.set('User-Agent', String(userAgent));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/reporting/controlling/excel/mandant/external-anmeldungen${this.configuration.encodeParam({name: "externalAnmeldungen", value: externalAnmeldungen, in: "path", style: "matrix", explode: true, dataType: "ReportingBetriebResourceGetAbweichungenKinderortFraktionReportFraktionIdMatrixParameter", dataFormat: undefined})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<JaxTempBlob>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public getFinanzlastenausgleich$(requestParameters: ReportingControllingApiGetFinanzlastenausgleichRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<JaxTempBlob>;
    public getFinanzlastenausgleich$(requestParameters: ReportingControllingApiGetFinanzlastenausgleichRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<JaxTempBlob>>;
    public getFinanzlastenausgleich$(requestParameters: ReportingControllingApiGetFinanzlastenausgleichRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<JaxTempBlob>>;
    public getFinanzlastenausgleich$(requestParameters: ReportingControllingApiGetFinanzlastenausgleichRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const finanzlastenausgleich = requestParameters.finanzlastenausgleich;
        if (finanzlastenausgleich === null || finanzlastenausgleich === undefined) {
            throw new Error('Required parameter finanzlastenausgleich was null or undefined when calling getFinanzlastenausgleich$.');
        }
        const userAgent = requestParameters.userAgent;
        const jaxParameterKitas = requestParameters.jaxParameterKitas;
        if (jaxParameterKitas === null || jaxParameterKitas === undefined) {
            throw new Error('Required parameter jaxParameterKitas was null or undefined when calling getFinanzlastenausgleich$.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (userAgent !== undefined && userAgent !== null) {
            localVarHeaders = localVarHeaders.set('User-Agent', String(userAgent));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/reporting/controlling/excel/finanzlastenausgleich${this.configuration.encodeParam({name: "finanzlastenausgleich", value: finanzlastenausgleich, in: "path", style: "matrix", explode: true, dataType: "ReportingBetriebResourceGetAdresslisteKinderKontakteKinderkontakteParameter", dataFormat: undefined})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<JaxTempBlob>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: jaxParameterKitas,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public getGroupAdminKindTagesInfos$(requestParameters: ReportingControllingApiGetGroupAdminKindTagesInfosRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public getGroupAdminKindTagesInfos$(requestParameters: ReportingControllingApiGetGroupAdminKindTagesInfosRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public getGroupAdminKindTagesInfos$(requestParameters: ReportingControllingApiGetGroupAdminKindTagesInfosRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public getGroupAdminKindTagesInfos$(requestParameters: ReportingControllingApiGetGroupAdminKindTagesInfosRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const kindId = requestParameters.kindId;
        if (kindId === null || kindId === undefined) {
            throw new Error('Required parameter kindId was null or undefined when calling getGroupAdminKindTagesInfos$.');
        }
        const kindIdMatrix = requestParameters.kindIdMatrix;
        if (kindIdMatrix === null || kindIdMatrix === undefined) {
            throw new Error('Required parameter kindIdMatrix was null or undefined when calling getGroupAdminKindTagesInfos$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/reporting/controlling/groupadmin-kind-tagesinfos/${this.configuration.encodeParam({name: "kindId", value: kindId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}${this.configuration.encodeParam({name: "kindIdMatrix", value: kindIdMatrix, in: "path", style: "matrix", explode: true, dataType: "AdressenResourceGetMitbewohnerMitbewohnerParameter", dataFormat: undefined})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<any>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public getKalkulierteLeistungen$(requestParameters: ReportingControllingApiGetKalkulierteLeistungenRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<JaxTempBlob>;
    public getKalkulierteLeistungen$(requestParameters: ReportingControllingApiGetKalkulierteLeistungenRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<JaxTempBlob>>;
    public getKalkulierteLeistungen$(requestParameters: ReportingControllingApiGetKalkulierteLeistungenRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<JaxTempBlob>>;
    public getKalkulierteLeistungen$(requestParameters: ReportingControllingApiGetKalkulierteLeistungenRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const kalkuliert = requestParameters.kalkuliert;
        if (kalkuliert === null || kalkuliert === undefined) {
            throw new Error('Required parameter kalkuliert was null or undefined when calling getKalkulierteLeistungen$.');
        }
        const kinderOrtId = requestParameters.kinderOrtId;
        if (kinderOrtId === null || kinderOrtId === undefined) {
            throw new Error('Required parameter kinderOrtId was null or undefined when calling getKalkulierteLeistungen$.');
        }
        const userAgent = requestParameters.userAgent;

        let localVarHeaders = this.defaultHeaders;
        if (userAgent !== undefined && userAgent !== null) {
            localVarHeaders = localVarHeaders.set('User-Agent', String(userAgent));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/reporting/controlling/excel/kita/${this.configuration.encodeParam({name: "kinderOrtId", value: kinderOrtId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}/leistungen/kalkuliert${this.configuration.encodeParam({name: "kalkuliert", value: kalkuliert, in: "path", style: "matrix", explode: true, dataType: "ReportingBetriebResourceGetAbweichungenKinderortFraktionReportFraktionIdMatrixParameter", dataFormat: undefined})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<JaxTempBlob>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public getKalkuliertesTarifreporting$(requestParameters: ReportingControllingApiGetKalkuliertesTarifreportingRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<JaxTempBlob>;
    public getKalkuliertesTarifreporting$(requestParameters: ReportingControllingApiGetKalkuliertesTarifreportingRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<JaxTempBlob>>;
    public getKalkuliertesTarifreporting$(requestParameters: ReportingControllingApiGetKalkuliertesTarifreportingRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<JaxTempBlob>>;
    public getKalkuliertesTarifreporting$(requestParameters: ReportingControllingApiGetKalkuliertesTarifreportingRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const kinderOrtId = requestParameters.kinderOrtId;
        if (kinderOrtId === null || kinderOrtId === undefined) {
            throw new Error('Required parameter kinderOrtId was null or undefined when calling getKalkuliertesTarifreporting$.');
        }
        const kinderOrtIdMatrix = requestParameters.kinderOrtIdMatrix;
        if (kinderOrtIdMatrix === null || kinderOrtIdMatrix === undefined) {
            throw new Error('Required parameter kinderOrtIdMatrix was null or undefined when calling getKalkuliertesTarifreporting$.');
        }
        const userAgent = requestParameters.userAgent;

        let localVarHeaders = this.defaultHeaders;
        if (userAgent !== undefined && userAgent !== null) {
            localVarHeaders = localVarHeaders.set('User-Agent', String(userAgent));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/reporting/controlling/excel/tarifrechnungreporting/kalkuliert/${this.configuration.encodeParam({name: "kinderOrtId", value: kinderOrtId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}${this.configuration.encodeParam({name: "kinderOrtIdMatrix", value: kinderOrtIdMatrix, in: "path", style: "matrix", explode: true, dataType: "ReportingBetriebResourceGetAbweichungenKinderortFraktionReportFraktionIdMatrixParameter", dataFormat: undefined})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<JaxTempBlob>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public getKennzahlen$(requestParameters: ReportingControllingApiGetKennzahlenRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<JaxTempBlob>;
    public getKennzahlen$(requestParameters: ReportingControllingApiGetKennzahlenRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<JaxTempBlob>>;
    public getKennzahlen$(requestParameters: ReportingControllingApiGetKennzahlenRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<JaxTempBlob>>;
    public getKennzahlen$(requestParameters: ReportingControllingApiGetKennzahlenRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const kennzahlen = requestParameters.kennzahlen;
        if (kennzahlen === null || kennzahlen === undefined) {
            throw new Error('Required parameter kennzahlen was null or undefined when calling getKennzahlen$.');
        }
        const userAgent = requestParameters.userAgent;

        let localVarHeaders = this.defaultHeaders;
        if (userAgent !== undefined && userAgent !== null) {
            localVarHeaders = localVarHeaders.set('User-Agent', String(userAgent));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/reporting/controlling/excel/mandant/kennzahlen${this.configuration.encodeParam({name: "kennzahlen", value: kennzahlen, in: "path", style: "matrix", explode: true, dataType: "ReportingBetriebResourceGetAbweichungenKinderortFraktionReportFraktionIdMatrixParameter", dataFormat: undefined})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<JaxTempBlob>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public getKibonDaten$(requestParameters: ReportingControllingApiGetKibonDatenRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<JaxTempBlob>;
    public getKibonDaten$(requestParameters: ReportingControllingApiGetKibonDatenRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<JaxTempBlob>>;
    public getKibonDaten$(requestParameters: ReportingControllingApiGetKibonDatenRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<JaxTempBlob>>;
    public getKibonDaten$(requestParameters: ReportingControllingApiGetKibonDatenRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const kibonReport = requestParameters.kibonReport;
        if (kibonReport === null || kibonReport === undefined) {
            throw new Error('Required parameter kibonReport was null or undefined when calling getKibonDaten$.');
        }
        const userAgent = requestParameters.userAgent;
        const jaxParameterKitas = requestParameters.jaxParameterKitas;
        if (jaxParameterKitas === null || jaxParameterKitas === undefined) {
            throw new Error('Required parameter jaxParameterKitas was null or undefined when calling getKibonDaten$.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (userAgent !== undefined && userAgent !== null) {
            localVarHeaders = localVarHeaders.set('User-Agent', String(userAgent));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/reporting/controlling/excel/kibonReport${this.configuration.encodeParam({name: "kibonReport", value: kibonReport, in: "path", style: "matrix", explode: true, dataType: "ReportingBetriebResourceGetAdresslisteKinderKontakteKinderkontakteParameter", dataFormat: undefined})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<JaxTempBlob>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: jaxParameterKitas,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public getKindStundenvergleich$(requestParameters: ReportingControllingApiGetKindStundenvergleichRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<JaxTempBlob>;
    public getKindStundenvergleich$(requestParameters: ReportingControllingApiGetKindStundenvergleichRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<JaxTempBlob>>;
    public getKindStundenvergleich$(requestParameters: ReportingControllingApiGetKindStundenvergleichRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<JaxTempBlob>>;
    public getKindStundenvergleich$(requestParameters: ReportingControllingApiGetKindStundenvergleichRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const kindId = requestParameters.kindId;
        if (kindId === null || kindId === undefined) {
            throw new Error('Required parameter kindId was null or undefined when calling getKindStundenvergleich$.');
        }
        const kindIdMatrix = requestParameters.kindIdMatrix;
        if (kindIdMatrix === null || kindIdMatrix === undefined) {
            throw new Error('Required parameter kindIdMatrix was null or undefined when calling getKindStundenvergleich$.');
        }
        const userAgent = requestParameters.userAgent;

        let localVarHeaders = this.defaultHeaders;
        if (userAgent !== undefined && userAgent !== null) {
            localVarHeaders = localVarHeaders.set('User-Agent', String(userAgent));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/reporting/controlling/excel/stundenvergleich/${this.configuration.encodeParam({name: "kindId", value: kindId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}${this.configuration.encodeParam({name: "kindIdMatrix", value: kindIdMatrix, in: "path", style: "matrix", explode: true, dataType: "ReportingBetriebResourceGetAbweichungenKinderortFraktionReportFraktionIdMatrixParameter", dataFormat: undefined})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<JaxTempBlob>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public getMonatsblattAuszug$(requestParameters: ReportingControllingApiGetMonatsblattAuszugRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public getMonatsblattAuszug$(requestParameters: ReportingControllingApiGetMonatsblattAuszugRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public getMonatsblattAuszug$(requestParameters: ReportingControllingApiGetMonatsblattAuszugRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public getMonatsblattAuszug$(requestParameters: ReportingControllingApiGetMonatsblattAuszugRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const kinderOrtId = requestParameters.kinderOrtId;
        if (kinderOrtId === null || kinderOrtId === undefined) {
            throw new Error('Required parameter kinderOrtId was null or undefined when calling getMonatsblattAuszug$.');
        }
        const monatsblaetter = requestParameters.monatsblaetter;
        if (monatsblaetter === null || monatsblaetter === undefined) {
            throw new Error('Required parameter monatsblaetter was null or undefined when calling getMonatsblattAuszug$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/reporting/controlling/zip/kinderort/${this.configuration.encodeParam({name: "kinderOrtId", value: kinderOrtId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}/monatsblaetter${this.configuration.encodeParam({name: "monatsblaetter", value: monatsblaetter, in: "path", style: "matrix", explode: true, dataType: "ReportingControllingResourceGetMonatsblattAuszugMonatsblaetterParameter", dataFormat: undefined})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<any>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public getPraesenzkontrolleFraktionReport$(requestParameters: ReportingControllingApiGetPraesenzkontrolleFraktionReportRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<JaxTempBlob>;
    public getPraesenzkontrolleFraktionReport$(requestParameters: ReportingControllingApiGetPraesenzkontrolleFraktionReportRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<JaxTempBlob>>;
    public getPraesenzkontrolleFraktionReport$(requestParameters: ReportingControllingApiGetPraesenzkontrolleFraktionReportRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<JaxTempBlob>>;
    public getPraesenzkontrolleFraktionReport$(requestParameters: ReportingControllingApiGetPraesenzkontrolleFraktionReportRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const fraktionen = requestParameters.fraktionen;
        if (fraktionen === null || fraktionen === undefined) {
            throw new Error('Required parameter fraktionen was null or undefined when calling getPraesenzkontrolleFraktionReport$.');
        }
        const userAgent = requestParameters.userAgent;

        let localVarHeaders = this.defaultHeaders;
        if (userAgent !== undefined && userAgent !== null) {
            localVarHeaders = localVarHeaders.set('User-Agent', String(userAgent));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/reporting/controlling/excel/praesenzkontrolle/fraktionen${this.configuration.encodeParam({name: "fraktionen", value: fraktionen, in: "path", style: "matrix", explode: true, dataType: "ReportingControllingResourceGetPraesenzkontrolleFraktionReportFraktionenParameter", dataFormat: undefined})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<JaxTempBlob>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public getPraesenzkontrolleKgFraktionReport$(requestParameters: ReportingControllingApiGetPraesenzkontrolleKgFraktionReportRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<JaxTempBlob>;
    public getPraesenzkontrolleKgFraktionReport$(requestParameters: ReportingControllingApiGetPraesenzkontrolleKgFraktionReportRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<JaxTempBlob>>;
    public getPraesenzkontrolleKgFraktionReport$(requestParameters: ReportingControllingApiGetPraesenzkontrolleKgFraktionReportRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<JaxTempBlob>>;
    public getPraesenzkontrolleKgFraktionReport$(requestParameters: ReportingControllingApiGetPraesenzkontrolleKgFraktionReportRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const fraktionen = requestParameters.fraktionen;
        if (fraktionen === null || fraktionen === undefined) {
            throw new Error('Required parameter fraktionen was null or undefined when calling getPraesenzkontrolleKgFraktionReport$.');
        }
        const userAgent = requestParameters.userAgent;

        let localVarHeaders = this.defaultHeaders;
        if (userAgent !== undefined && userAgent !== null) {
            localVarHeaders = localVarHeaders.set('User-Agent', String(userAgent));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/reporting/controlling/excel/praesenzkontrollekg/fraktionen${this.configuration.encodeParam({name: "fraktionen", value: fraktionen, in: "path", style: "matrix", explode: true, dataType: "ReportingControllingResourceGetPraesenzkontrolleKgFraktionReportFraktionenParameter", dataFormat: undefined})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<JaxTempBlob>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public getPraesenzkontrolleKgReport$(requestParameters: ReportingControllingApiGetPraesenzkontrolleKgReportRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<JaxTempBlob>;
    public getPraesenzkontrolleKgReport$(requestParameters: ReportingControllingApiGetPraesenzkontrolleKgReportRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<JaxTempBlob>>;
    public getPraesenzkontrolleKgReport$(requestParameters: ReportingControllingApiGetPraesenzkontrolleKgReportRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<JaxTempBlob>>;
    public getPraesenzkontrolleKgReport$(requestParameters: ReportingControllingApiGetPraesenzkontrolleKgReportRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const kinderOrtId = requestParameters.kinderOrtId;
        if (kinderOrtId === null || kinderOrtId === undefined) {
            throw new Error('Required parameter kinderOrtId was null or undefined when calling getPraesenzkontrolleKgReport$.');
        }
        const kinderOrtIdMatrix = requestParameters.kinderOrtIdMatrix;
        if (kinderOrtIdMatrix === null || kinderOrtIdMatrix === undefined) {
            throw new Error('Required parameter kinderOrtIdMatrix was null or undefined when calling getPraesenzkontrolleKgReport$.');
        }
        const userAgent = requestParameters.userAgent;

        let localVarHeaders = this.defaultHeaders;
        if (userAgent !== undefined && userAgent !== null) {
            localVarHeaders = localVarHeaders.set('User-Agent', String(userAgent));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/reporting/controlling/excel/praesenzkontrollekg/kinderort/${this.configuration.encodeParam({name: "kinderOrtId", value: kinderOrtId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}${this.configuration.encodeParam({name: "kinderOrtIdMatrix", value: kinderOrtIdMatrix, in: "path", style: "matrix", explode: true, dataType: "ReportingBetriebResourceGetAbweichungenKinderortFraktionReportFraktionIdMatrixParameter", dataFormat: undefined})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<JaxTempBlob>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public getPraesenzkontrolleReport$(requestParameters: ReportingControllingApiGetPraesenzkontrolleReportRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<JaxTempBlob>;
    public getPraesenzkontrolleReport$(requestParameters: ReportingControllingApiGetPraesenzkontrolleReportRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<JaxTempBlob>>;
    public getPraesenzkontrolleReport$(requestParameters: ReportingControllingApiGetPraesenzkontrolleReportRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<JaxTempBlob>>;
    public getPraesenzkontrolleReport$(requestParameters: ReportingControllingApiGetPraesenzkontrolleReportRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const kinderOrtId = requestParameters.kinderOrtId;
        if (kinderOrtId === null || kinderOrtId === undefined) {
            throw new Error('Required parameter kinderOrtId was null or undefined when calling getPraesenzkontrolleReport$.');
        }
        const kinderOrtIdMatrix = requestParameters.kinderOrtIdMatrix;
        if (kinderOrtIdMatrix === null || kinderOrtIdMatrix === undefined) {
            throw new Error('Required parameter kinderOrtIdMatrix was null or undefined when calling getPraesenzkontrolleReport$.');
        }
        const userAgent = requestParameters.userAgent;

        let localVarHeaders = this.defaultHeaders;
        if (userAgent !== undefined && userAgent !== null) {
            localVarHeaders = localVarHeaders.set('User-Agent', String(userAgent));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/reporting/controlling/excel/praesenzkontrolle/kinderort/${this.configuration.encodeParam({name: "kinderOrtId", value: kinderOrtId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}${this.configuration.encodeParam({name: "kinderOrtIdMatrix", value: kinderOrtIdMatrix, in: "path", style: "matrix", explode: true, dataType: "ReportingControllingResourceGetPraesenzkontrolleReportKinderOrtIdMatrixParameter", dataFormat: undefined})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<JaxTempBlob>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public getStundenbasiertesControlling$(requestParameters: ReportingControllingApiGetStundenbasiertesControllingRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<JaxTempBlob>;
    public getStundenbasiertesControlling$(requestParameters: ReportingControllingApiGetStundenbasiertesControllingRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<JaxTempBlob>>;
    public getStundenbasiertesControlling$(requestParameters: ReportingControllingApiGetStundenbasiertesControllingRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<JaxTempBlob>>;
    public getStundenbasiertesControlling$(requestParameters: ReportingControllingApiGetStundenbasiertesControllingRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const jahr = requestParameters.jahr;
        if (jahr === null || jahr === undefined) {
            throw new Error('Required parameter jahr was null or undefined when calling getStundenbasiertesControlling$.');
        }
        const jahrMatrix = requestParameters.jahrMatrix;
        if (jahrMatrix === null || jahrMatrix === undefined) {
            throw new Error('Required parameter jahrMatrix was null or undefined when calling getStundenbasiertesControlling$.');
        }
        const kinderOrtId = requestParameters.kinderOrtId;
        if (kinderOrtId === null || kinderOrtId === undefined) {
            throw new Error('Required parameter kinderOrtId was null or undefined when calling getStundenbasiertesControlling$.');
        }
        const userAgent = requestParameters.userAgent;

        let localVarHeaders = this.defaultHeaders;
        if (userAgent !== undefined && userAgent !== null) {
            localVarHeaders = localVarHeaders.set('User-Agent', String(userAgent));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/reporting/controlling/excel/tageseltern/${this.configuration.encodeParam({name: "kinderOrtId", value: kinderOrtId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}/stundenbasiertes_controlling/jahresauswertung/${this.configuration.encodeParam({name: "jahr", value: jahr, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int32"})}${this.configuration.encodeParam({name: "jahrMatrix", value: jahrMatrix, in: "path", style: "matrix", explode: true, dataType: "ReportingBetriebResourceGetAdresslisteKinderKontakteKinderkontakteParameter", dataFormat: undefined})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<JaxTempBlob>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public getStundenblatt$(requestParameters: ReportingControllingApiGetStundenblattRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<JaxTempBlob>;
    public getStundenblatt$(requestParameters: ReportingControllingApiGetStundenblattRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<JaxTempBlob>>;
    public getStundenblatt$(requestParameters: ReportingControllingApiGetStundenblattRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<JaxTempBlob>>;
    public getStundenblatt$(requestParameters: ReportingControllingApiGetStundenblattRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const kinderOrtId = requestParameters.kinderOrtId;
        if (kinderOrtId === null || kinderOrtId === undefined) {
            throw new Error('Required parameter kinderOrtId was null or undefined when calling getStundenblatt$.');
        }
        const stundenblatt = requestParameters.stundenblatt;
        if (stundenblatt === null || stundenblatt === undefined) {
            throw new Error('Required parameter stundenblatt was null or undefined when calling getStundenblatt$.');
        }
        const userAgent = requestParameters.userAgent;

        let localVarHeaders = this.defaultHeaders;
        if (userAgent !== undefined && userAgent !== null) {
            localVarHeaders = localVarHeaders.set('User-Agent', String(userAgent));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/reporting/controlling/excel/kita/${this.configuration.encodeParam({name: "kinderOrtId", value: kinderOrtId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}/stundenblatt${this.configuration.encodeParam({name: "stundenblatt", value: stundenblatt, in: "path", style: "matrix", explode: true, dataType: "ReportingBetriebResourceGetAbweichungenKinderortFraktionReportFraktionIdMatrixParameter", dataFormat: undefined})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<JaxTempBlob>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public getWarteliste$(requestParameters: ReportingControllingApiGetWartelisteRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<JaxTempBlob>;
    public getWarteliste$(requestParameters: ReportingControllingApiGetWartelisteRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<JaxTempBlob>>;
    public getWarteliste$(requestParameters: ReportingControllingApiGetWartelisteRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<JaxTempBlob>>;
    public getWarteliste$(requestParameters: ReportingControllingApiGetWartelisteRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const warteliste = requestParameters.warteliste;
        if (warteliste === null || warteliste === undefined) {
            throw new Error('Required parameter warteliste was null or undefined when calling getWarteliste$.');
        }
        const userAgent = requestParameters.userAgent;
        const jaxParameterKitas = requestParameters.jaxParameterKitas;
        if (jaxParameterKitas === null || jaxParameterKitas === undefined) {
            throw new Error('Required parameter jaxParameterKitas was null or undefined when calling getWarteliste$.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (userAgent !== undefined && userAgent !== null) {
            localVarHeaders = localVarHeaders.set('User-Agent', String(userAgent));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/reporting/controlling/excel/warteliste${this.configuration.encodeParam({name: "warteliste", value: warteliste, in: "path", style: "matrix", explode: true, dataType: "ReportingBetriebResourceGetAdresslisteKinderKontakteKinderkontakteParameter", dataFormat: undefined})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<JaxTempBlob>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: jaxParameterKitas,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
// @formatter:on
